import React, { Component } from "react";
import { Provider } from "react-redux";
import { Redirect } from "react-router";

import { API } from "../../../../api/api";
import { authStore } from "../../store/store";
import Background from "../../../../utils/Background/Background.component";
import AuthPage from "./AuthPage";

export default class Auth extends Component {
    render() {
        return API.getLoginStatus().loggedIn ? (
            <Redirect to="/" />
        ) : (
            <Provider store={authStore}>
                <Background />
                <AuthPage />
            </Provider>
        );
    }
}

